import { Message } from "@/types";
import { getStringContent } from "@/utils/utils";
import { truncateBase64InObject } from "@/utils/strings";

export const getJsonText = (value: unknown) => {
  try {
    return JSON.stringify(truncateBase64InObject(value), undefined, 2);
  } catch {
    return JSON.stringify({ error: "Unable to render JSON for this message." }, undefined, 2);
  }
};

export const getMessageRoleLabel = (message: Message) => {
  if (
    message.role === "assistant" ||
    message.role === "user" ||
    message.role === "tool" ||
    message.role === "function"
  ) {
    return "";
  }

  return (message.raw_request_display_role || message.role).toUpperCase();
};

export const getMessageBubbleClassName = (message: Message) => {
  if (message.role === "system") {
    return "border border-slate-200 bg-slate-50 text-slate-700";
  }

  if (message.role === "developer") {
    return "border border-sky-200 bg-sky-50 text-sky-700";
  }

  if (message.role === "placeholder") {
    return "border border-dashed border-gray-200 bg-gray-50 text-gray-500";
  }

  return undefined;
};

export const getTraceMessagePreviewText = (message: Message) => {
  const textContent = getStringContent(message).replace(/\s+/g, " ").trim();
  if (textContent) {
    return textContent;
  }

  if (message.role === "assistant" && message.tool_calls?.length) {
    return `${message.tool_calls.length} tool call${message.tool_calls.length === 1 ? "" : "s"}`;
  }

  if ((message.role === "tool" || message.role === "function") && message.name) {
    return `${message.name} response`;
  }

  return "No text content";
};
